import { render, staticRenderFns } from "./sysModuleCreate.vue?vue&type=template&id=c3b520e6&scoped=true&"
import script from "./sysModuleCreate.vue?vue&type=script&lang=js&"
export * from "./sysModuleCreate.vue?vue&type=script&lang=js&"
import style0 from "./sysModuleCreate.vue?vue&type=style&index=0&id=c3b520e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3b520e6",
  null
  
)

export default component.exports